import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const servicePoints: string[] = [
  'La mentoría de reflexión estratégica es un enfoque de desarrollo personal orientado a impulsar un cambio significativo en la efectividad de un líder.',
  'Un mentor personal y de reflexión estratégica te acompañará de cerca en tu proceso de toma de decisiones, crecimiento profesional y transición de carrera desde la claridad, la confianza y el desarrollo del potencial humano.',
  'Al integrarte a una nueva organización o asumir una posición de mayor responsabilidad, la mentoría estratégica se centra en acelerar tu transición mediante un proceso estructurado de integración que facilitará tu adaptación.',
];

const audienceItems: string[] = [
  'Personas con alto potencial que buscan claridad para dar el siguiente paso.',
  'Nuevos gerentes o líderes que acaban de asumir un rol de liderazgo y buscan hacer una transición de colaborador a líder efectivo desde la confianza y la claridad.',
  'Hombres y mujeres que ya han logrado mucho y hoy enfrentan dudas, bloqueos o decisiones relevantes.',
  'Líderes que enfrentan procesos de cambio organizacional y necesitan acompañamiento para guiar a sus equipos con claridad y confianza de un estado actual a uno deseado.',
  'Líderes en corporativos, empresas nacionales y globales. Líderes en funciones clave como manufactura, operaciones, finanzas y recursos humanos.',
];

const includes: string[] = [
  'Sesiones 1 a 1 en una frecuencia semanal recomendada de forma inicial y posteriormente quincenales.',
  'Recomendaciones de herramientas específicas para tu desarrollo, lecturas, autoevaluaciones, blogs, etc.',
  'El método es flexible y depende de la situación, pero usualmente se utilizan de 5 a 10 sesiones como mínimo. Pueden ser más o menos dependiendo de la situación particular a trabajar.',
];

export default function ServiciosPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50">
        {/* Header */}
        <section className="w-full pt-24 pb-8 md:pt-32 md:pb-12">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-[0.02em] text-foreground-900 leading-[1.05]">
              SERVICIOS
            </h1>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* Contenido principal */}
        <section className="w-full py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              {/* Columna izquierda */}
              <div className="space-y-6">
                {servicePoints.map((point, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0" />
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {point}
                    </p>
                  </div>
                ))}
              </div>

              {/* Columna derecha */}
              <div className="space-y-10">
                {/* A quien va dirigido */}
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-5">
                    ¿A quién va dirigido?
                  </h3>
                  <div className="space-y-3">
                    {audienceItems.map((item, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <span className="mt-2 w-1 h-1 rounded-full bg-accent-400 flex-shrink-0" />
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* INCLUYE */}
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-5">
                    INCLUYE
                  </h3>
                  <div className="space-y-3">
                    {includes.map((item, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <span className="mt-2 w-1 h-1 rounded-full bg-accent-400 flex-shrink-0" />
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* CTA */}
        <section className="w-full py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl">
                Agenda una sesión sin costo para que juntos descubramos cómo puedes seguir avanzando en tu carrera profesional.
              </p>
              <Link
                to="/agenda"
                className="inline-block px-8 py-3.5 rounded-md text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-accent-500 text-background-50 hover:bg-accent-600"
              >
                Agenda una sesión
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}